import { offset, shift } from "@floating-ui/react";
import { inject } from "../ng";
import type { PopoverProps } from "../popover/popover";

export const popoverProps: PopoverProps = {
	placement: "left-start",
	middleware: [offset({ mainAxis: 6 }), shift()],
};

export function zoomToCurrentLocation() {
	inject("mapUtilities").zoomToCurrentLocation();
}

export const Search = () => (
	<a href="/app/search">
		<i className="ico ico-search" /> Search
	</a>
);

export const Zoom = () => (
	<button className="btn" type="button" onClick={zoomToCurrentLocation}>
		Zoom to your current location
	</button>
);
